// Styles for StepperTextBlock go here.
import styled from 'styled-components';

export const StyledStepperTextBlock = styled.div``;
